module.exports = __webpack_public_path__ + "images/common/bg_border_blue_7214b6c016cc3d2c5c6463c750d6771a.png";